import { Loader } from '@/shared/components/loader';

export function PageLoader() {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <Loader size="lg" label="Loading page" />
    </div>
  );
}
